async function getPosts() {
    let postCount = document.getElementById('external-blog').dataset.postCount;
    let blogUrl = 'https://blog.wellboxes.co.uk/wp-json/wp/v2/posts?per_page=' + postCount;
    let response = await fetch(blogUrl);
    let data = await response.json();
    return data;
}

function createPosts(data){
    
    let postTitle = data.title.rendered;
    let postLink = data.link;
    let excerpt = data.excerpt.rendered;
    let image = data.yoast_head_json.og_image



    let post = blog_post.content.cloneNode(true);

    post.querySelector('.blog-title').innerHTML = postTitle;
    post.querySelector('.blog-image').src = image[0].url;
    post.querySelector('.blog-image').alt = postTitle;
    post.querySelectorAll('.blog-link').forEach(tag => {
        tag.href = postLink;
    });

    addToPage(post);
}

function addToPage(post){
    var target = document.getElementById('external-blog');
    target.append(post);
}

getPosts().then(data => data.forEach(post => createPosts(post)));

if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", function(){
            getPosts().then(data => data.forEach(post => createPosts(post)));
        });
        document.addEventListener("shopify:section:unload", function(){
            getPosts().then(data => data.forEach(post => createPosts(post)));
        });
        document.addEventListener("shopify:section:reorder", function(){
            getPosts().then(data => data.forEach(post => createPosts(post)));
        });
    
  }